import React, { Component } from "react";
import moment from "moment";
import "./Table.css";
import _ from "lodash";
import { connect } from "react-redux";
import { sort } from "d3-array";

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredData: [],
      sortBy: null,
    };
  }

  getsortyKey() {
    const isExist = _.find(this.props.heads, ["key", "battery_temp"]);
    const isExist2 = _.find(this.props.heads, ["key", "soc"]);

    if (isExist) {
      return "battery_temp";
    } else if (isExist2) {
      return "soc";
    } else {
      return "soc";
    }
  }
  componentDidMount() {
    this.setState({ sortBy: { by: "desc", key: this.getsortyKey() } });
  }
  getTableData() {
    let distance = [];
    for (const [key, value] of Object.entries(this.props.data)) {
      distance.push(value);
    }

    return distance;
  }

  getSOCRowBackground(value) {
    if (value === null) return "";

    if (value >= 0 && value <= 25) {
      return "#f05f60";
    } else if (value >= 25 && value <= 50) {
      return "rgb(255, 196, 120)";
    } else if (value >= 50 && value <= 75) {
      return "rgb(94, 170, 168)";
    } else if (value > 100 || value < 0) {
      return "#B4846C";
    } else {
      return "rgb(91, 204, 91) ";
    }
  }

  getTempRowBackground(value) {
    if (value === null) return "";
    if (value >= 0 && value <= 15) {
      return "rgb(94, 170, 168)";
    } else if (value >= 15 && value <= 30) {
      return "rgb(91 204 91)";
    } else if (value >= 30 && value <= 45) {
      return "rgb(255 196 120)";
    } else if (value > 100 || value < -20) {
      return "#B4846C";
    } else {
      return "#f05f60";
    }
  }
  sortByColumn(head) {
    var sortType = "";
    let sortData = {
      by: null,
      key: null,
    };
    if (this.state.sortBy === null || this.state.sortBy.by === "desc") {
      sortData.by = "asc";
      sortType = "asc";
      sortData.key = head;
      this.setState({ sortBy: sortData });
    } else {
      sortData.by = "desc";
      sortType = "desc";
      sortData.key = head;
      this.setState({ sortBy: sortData });
    }

    let sortingData = this.props.data;

    let sortedData = _.orderBy(sortingData, [head], [sortData.by]);
    sortedData.sort(function (a, b) {
      return (a[head] === null) - (b[head] === null);
    });
    this.props.dispatch({
      type: "UPDATE_EV_DASHBOARD_DATA",
      payload: { data: sortedData, key: this.props.metric },
    });
    // this.setState({filteredData:sortedData});
  }
  getSortIcon = (item) => {
    if (this.state.sortBy && item === this.state.sortBy.key) {
      if (this.state.sortBy.by === "asc") {
        return <i className="fa fa-sort-amount-desc"></i>;
      } else {
        return <i className="fa fa-sort-amount-asc"></i>;
      }
    }
  };

  download_csv = (csv, filename) => {
    var csvFile;
    var downloadLink;
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");

    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  };
  getReportDownload = () => {
    var csv = [];
    var tabledata = this.refs.tableRef;
    var rows = tabledata.querySelectorAll("tr");

    for (var i = 0; i < rows.length; i++) {
      var row = [],
        cols = rows[i].querySelectorAll("td, th");

      for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);

      csv.push(row.join(","));
    }
    this.download_csv(csv.join("\n"), `${this.props.filename}.csv`);
  };

  renderHead() {
    let heading = [];
    for (let idx in this.props.heads) {
      heading.push(
        <th
          key={idx}
          style={{
            top: -3,
            width: idx == 0 ? "30%" : 75 / this.props.heads.length - 1 + "%",
            textAlign: this.getAlign(this.props.heads[idx]),
          }}
          onClick={() => this.sortByColumn(this.props.heads[idx].key)}
        >
          {this.getSortIcon(this.props.heads[idx].key)}{" "}
          {this.props.heads[idx].heading}
        </th>
      );
    }
    return heading;
  }

  getAlign(head) {
    switch (head.key) {
      case "time":
        return "center";
      case "vehno":
        return "left";
      case "vehicleno":
        return "left";
      case "starttime":
        return "center";

      default:
        return "right";
    }
  }
  render() {
    return (
      <div className="tableContainer">
        <table ref="tableRef" id={this.props.tableId}>
          <thead>
            <tr>{this.renderHead()}</tr>
          </thead>
          <tbody>
            {this.props.data.map((data, key) => {
              return (
                <tr key={key}>
                  {this.props.heads.map((head, key) => {
                    return this.props.colorOn ? (
                      <td
                        style={{
                          backgroundColor:
                            this.props.colorOn === "soc" && head.key === "soc"
                              ? this.getSOCRowBackground(data["soc"])
                              : head.key === "battery_temp"
                              ? this.getTempRowBackground(data["battery_temp"])
                              : "",
                          textAlign: this.getAlign(head),
                        }}
                      >
                        {data[head.key] === null || data[head.key] === "NA" ? (
                          "NA"
                        ) : head.format === "time" &&
                          data[head.key] !== null ? (
                          <small>
                            {moment(data[head.key]).format("h:mm A")}
                            <br></br>
                            {moment(data[head.key]).format("D MMM YYYY")}
                          </small>
                        ) : (
                          data[head.key]
                        )}
                        {/* {head.unit && data[head.key] !== null
                          ? head.unit !== "%"
                            ? " " + head.unit
                            : head.unit
                          : ""} */}
                      </td>
                    ) : (
                      <td
                        style={{
                          backgroundColor:
                            this.props.metric === "todaydistance" &&
                            head.key === "soc" &&
                            data.totaldistance / data.soc > 3
                              ? "#B4846C"
                              : "",
                          textAlign: this.getAlign(head),
                        }}
                      >
                        {data[head.key] === null || data[head.key] === "NA" ? (
                          "NA"
                        ) : head.format === "time" &&
                          data[head.key] !== null ? (
                          <small>
                            {moment(data[head.key]).format("h:mm A")}
                            <br></br>
                            {moment(data[head.key]).format("D MMM YYYY")}
                          </small>
                        ) : (
                          data[head.key]
                        )}
                        {/* {head.unit && data[head.key] !== null
                          ? head.unit !== "%"
                            ? " " + head.unit
                            : head.unit
                          : ""} */}
                      </td>
                    );
                  })}
                  {/* <td>{data.vehicleno}</td>
        <td>{data.totaldistance===null?"NA":data.totaldistance +" km"}</td>
        <td>{data.soc===null?"NA":data.soc}</td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
const mapPropsToState = (state) => {
  return {
    dashbaord: state.evDashboard,
  };
};

export default connect(mapPropsToState)(Table);
